import { render, staticRenderFns } from "./store_merchant_binding.vue?vue&type=template&id=33b179ec&scoped=true"
import script from "./store_merchant_binding.vue?vue&type=script&lang=js"
export * from "./store_merchant_binding.vue?vue&type=script&lang=js"
import style0 from "./store_merchant_binding.vue?vue&type=style&index=0&id=33b179ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b179ec",
  null
  
)

export default component.exports